var _rect, _path, _circle, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 23,
    viewBox: "0 0 70 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 5,
    width: 27,
    height: 13,
    rx: 6.5,
    fill: "#D3E2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7297 14V8.90785H49.7854C50.1777 8.90785 50.5033 8.96931 50.7622 9.09223C51.0212 9.21254 51.2147 9.37469 51.3428 9.57869C51.471 9.78269 51.5351 10.0089 51.5351 10.2574C51.5351 10.5451 51.454 10.7909 51.2918 10.9949C51.1323 11.1989 50.9074 11.3428 50.6171 11.4265C50.808 11.4657 50.9793 11.5376 51.131 11.6422C51.2827 11.7468 51.4017 11.8789 51.488 12.0385C51.5769 12.198 51.6214 12.3811 51.6214 12.5877C51.6214 12.7498 51.5926 12.9133 51.5351 13.0781C51.4802 13.2428 51.3834 13.3958 51.2448 13.5371C51.1088 13.6757 50.9218 13.7882 50.6838 13.8745C50.4484 13.9582 50.1515 14 49.7932 14H47.7297ZM48.6555 13.1918H49.7697C50.0652 13.1918 50.281 13.133 50.417 13.0153C50.5556 12.895 50.6249 12.7342 50.6249 12.5328C50.6249 12.3314 50.5543 12.1705 50.4131 12.0502C50.2718 11.9273 50.0574 11.8658 49.7697 11.8658H48.6555V13.1918ZM48.6555 9.70815V11.0577H49.7462C50.0208 11.0577 50.2287 10.9975 50.3699 10.8772C50.5138 10.7543 50.5857 10.5869 50.5857 10.3751C50.5857 10.1737 50.5151 10.0128 50.3738 9.89254C50.2352 9.76962 50.0286 9.70815 49.754 9.70815H48.6555ZM52.8096 14V8.90785H56.0814V9.70815H53.7354V11.0498H55.9402V11.8502H53.7354V13.1918H56.0814V14H52.8096ZM56.7398 9.70815V8.90785H60.8198V9.70815H59.0348L59.2428 9.49631V14H58.3169V9.49631L58.5248 9.70815H56.7398ZM60.6812 14L62.4152 8.90785H63.5764L65.2398 14H64.2669L63.9138 12.9015H62.0229L61.6619 14H60.6812ZM62.2583 12.2032H63.6941L62.9801 10.0142L62.2583 12.2032Z",
    fill: "#185ADB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8284,
    cy: 20.1409,
    r: 2.53201,
    fill: "#242A30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1247 5.03111C7.7636 5.03111 5.03111 7.76199 5.03111 11.1403C5.03111 13.9897 6.97809 16.3853 9.60876 17.0596C10.9545 17.4046 11.7659 18.7752 11.4209 20.121C11.0759 21.4668 9.70528 22.2781 8.35949 21.9331C3.55191 20.7008 0 16.3369 0 11.1403C0 4.99199 4.97639 0 11.1247 0C12.431 0 13.69 0.226551 14.861 0.644623C16.1694 1.11174 16.8515 2.5511 16.3843 3.85952C15.9172 5.16794 14.4779 5.84995 13.1694 5.38283C12.5335 5.15581 11.8464 5.03111 11.1247 5.03111Z",
    fill: "url(#paint0_linear_1443_1608)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5794 0.71875C24.5416 0.71875 25.4195 1.26759 25.8409 2.13257L34.2445 19.3821C34.853 20.6311 34.3337 22.1368 33.0848 22.7453C31.8358 23.3538 30.33 22.8345 29.7216 21.5856L23.5794 8.97798L20.5886 15.117C19.9801 16.366 18.4744 16.8852 17.2254 16.2767C15.9765 15.6682 15.4572 14.1625 16.0657 12.9135L21.318 2.13257C21.7394 1.26759 22.6172 0.71875 23.5794 0.71875Z",
    fill: "url(#paint1_linear_1443_1608)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7148 0.951445C25.9638 1.55992 26.483 3.06567 25.8746 4.31464L20.6223 15.0956C20.0138 16.3446 18.5081 16.8638 17.2591 16.2553C16.0101 15.6468 15.4909 14.1411 16.0994 12.8921L21.3517 2.11117C21.9601 0.862198 23.4659 0.342973 24.7148 0.951445Z",
    fill: "url(#paint2_linear_1443_1608)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1443_1608",
    x1: 11.9641,
    y1: 11.3343,
    x2: -0.00430561,
    y2: 1.8856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1443_1608",
    x1: 23.3024,
    y1: 5.66504,
    x2: 32.1212,
    y2: 22.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1443_1608",
    x1: 17.0038,
    y1: 15.7437,
    x2: 23.9329,
    y2: 2.51547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185ADB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logo-sidebar.a17b5381b8f4ee4a2936d704a44e0306.svg";
export { ForwardRef as ReactComponent };